import styled from '@emotion/styled'
import { Flex } from 'rebass'

const ScoreCardContainer = styled(Flex)`
  padding: 0px 5px;
  width: 100px;
  height: 85px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.white};
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const ScoreText = styled('span')`
  text-transform: uppercase;
  padding-top: 5px;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

const Score = styled('span')`
  font-size: 45px;
  color: ${({ theme }) => theme.colors.text.primary};
`

const ScoreCard = ({ score }) => {
  return (
    <ScoreCardContainer>
      <ScoreText>Score</ScoreText>
      <Score>{score}</Score>
    </ScoreCardContainer>
  )
}

export default ScoreCard
